import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=36da91d2&"
import script from "./ChatWindow.vue?vue&type=script&lang=js&"
export * from "./ChatWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports